import { render, staticRenderFns } from "./main-card.vue?vue&type=template&id=13866fd6"
import script from "./main-card.vue?vue&type=script&lang=js"
export * from "./main-card.vue?vue&type=script&lang=js"
import style0 from "./main-card.vue?vue&type=style&index=0&id=13866fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports